import type { CourseAttendance } from "@/lib/api/attendance";
import { classTitle } from "@/lib/class-name";
import { formatInCourseZone } from "@/lib/session-portal";
import { registerPhrases, registerText } from "@/lib/register-copy";

export type RosterLearner = CourseAttendance["roster"][number];
export type RosterSession = CourseAttendance["sessions"][number];

const words = {
  present: "Present",
  absent: "Absent",
  excused: "Excused",
  late: "Late",
};

/** Marks from an authorized course read; the host owns reads and held-session filtering. */
export function LearnerMarks({
  learner,
  held,
  timezone,
}: {
  learner: RosterLearner;
  held: RosterSession[];
  timezone: string;
}) {
  if (!held.length) return <p>{registerText.noSessionHasBeenHeldYet}</p>;
  return (
    <ol
      aria-label={registerPhrases.marksFor(learner.preferred_name ?? learner.legal_name)}
      className="grid gap-2"
    >
      {held.map((session) => {
        const mark = learner.marks[session.id];
        return (
          <li key={session.id} className="flex flex-wrap justify-between gap-3">
            <span>
              {classTitle(session, timezone)} ·{" "}
              {session.starts_at
                ? formatInCourseZone(session.starts_at, timezone, {
                    month: "short",
                    day: "numeric",
                  })
                : session.session_date}
            </span>
            <span>
              {mark?.status ? words[mark.status] : registerText.notRecorded}
              {mark?.camera_on === false ? registerText.cameraOff : ""}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
